// eslint-disable-next-line import/prefer-default-export
export const FEATURE_FLAGS = {
  EXPENSE_TRACKER: 'expense_tracker',
  API_INTEGRATIONS: 'api_integrations',
  LEAD_MANAGEMENT: 'lead_management',
  TALLY_INTEGRATION: 'tally_integration',
  GST: 'gst',
  EVENTS: 'events',
  CUSTOM_TERM: 'custom_term',
  CLONE_GROUP: 'clone_group',
  MANUAL_PAYMENT_BANK_ACCOUNT_MAPPING: 'manual_payment_bank_account_mapping',
  ATTENDANCE_EXEMPT: 'attendance_exempt',
  EVENT_EMAIL: 'event_email',
  LEAD_SQUARED: 'leadsquared_integration',
  MEMBER_END_DATE: 'member_end_date',
  AUTO_DEBIT: 'auto_debit',
  EVENT_SUBTICKETS: 'event_subtickets',
  EVENT_COUPONS: 'event_coupons',
  GROUP_MEMBERS_DEFAULT_FILTER_ALL: 'group_members_default_filter_all'
};
